import { NoteTemplateData } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const noteTemplateRepository = repositoryHost.getNoteTemplateRepository(databaseService);

export const useNoteTemplates = () => {
  return useQuery({
    queryKey: ["note-templates", "get-all"],
    queryFn: () =>
      noteTemplateRepository.getAll({
        pagination: { limit: 200 },
        orderBy: { field: "createdAt", direction: "asc" },
      }),
  });
};

export const useCreateNoteTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: NoteTemplateData) =>
      noteTemplateRepository.create({ data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["note-templates"] });
    },
  });
};

export const useUpdateNoteTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { id: string; data: Partial<NoteTemplateData> }) =>
      noteTemplateRepository.update({ id: payload.id, data: payload.data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["note-templates"] });
    },
  });
};

export const useDeleteNoteTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => noteTemplateRepository.delete({ id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["note-templates"] });
    },
  });
};
